import { Button, Card, Typography } from '@lamimed/pantheon';
import Link from 'next/link';

import * as S from '../styles';

export enum ProductCardTarget {
  blank = '_blank',
  top = '_top',
  parent = '_parent',
  self = '_self',
}

interface ProductCardProps {
  link?: string;
  image?: string;
  title?: string;
  price?: string;
  buttonText?: string;
  target?: ProductCardTarget;
  badgeText?: string;
  handleClick?: () => void;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  link,
  image,
  title,
  price,
  buttonText = 'Seleziona',
  target,
  badgeText = '',
  handleClick,
}) => {
  const titleAndPrice = (
    <Typography variant="heading_4" color="text__light">
      {title}

      {!!price && ` - ${price}`}
    </Typography>
  );

  if (!link) {
    return (
      <S.LinkProxy onClick={handleClick}>
        <Card variant="hero" image={image}>
          <Card.Body variant="hero">
            {badgeText && (
              <S.Badge>
                <Typography variant="heading_4">{badgeText}</Typography>
              </S.Badge>
            )}

            {titleAndPrice}

            <S.Row>
              <Button variant="overlay">{buttonText}</Button>
            </S.Row>
          </Card.Body>
        </Card>
      </S.LinkProxy>
    );
  }

  return (
    <Link href={link} passHref legacyBehavior>
      <S.LinkProxy
        target={target}
        rel={
          target === ProductCardTarget.blank
            ? 'noopener noreferrer nofollow'
            : ''
        }
      >
        <Card variant="hero" image={image}>
          <Card.Body variant="hero">
            {badgeText && (
              <S.Badge>
                <Typography variant="heading_4">{badgeText}</Typography>
              </S.Badge>
            )}

            {titleAndPrice}

            <S.Row>
              <Button variant="overlay">{buttonText}</Button>
            </S.Row>
          </Card.Body>
        </Card>
      </S.LinkProxy>
    </Link>
  );
};
